let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ag7Oj")).then(() => parcelRequire('65bjo'));